module.exports = __webpack_public_path__ + "512ccef0ee74b53b871e5dd9127ce448.glb";